import { useQuery } from "@tanstack/react-query";

import { getCarbonProgramById, getCarbonProgramByIdAdmin } from "services";

import { getEnvironment } from "utils";

import { GET_CARBON_PROGRAM_BY_ID } from "consts";

import { CarbonProgram } from "models";

export const useGetCarbonProgramById = (programId?: string) => {
  const isAdmin = getEnvironment().admin;

  return useQuery<CarbonProgram | null>({
    queryKey: [GET_CARBON_PROGRAM_BY_ID, programId, isAdmin],
    queryFn: () => {
      if (!programId) return null;
      return isAdmin ? getCarbonProgramByIdAdmin(programId) : getCarbonProgramById(programId);
    },
    enabled: !!programId,
  });
};
